import React, { Component } from 'react'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken, InitPage } from 'src/helper/tool'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import { history } from 'src/core/router'
import http from 'src/helper/http'
@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.ruby = this.props.store.register('app/ruby')
  }

  state = {
    lang: langM.ar,
    language: 'en',
    applicationState: null,
    reason: '',
    showApplaView: false,
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language = await getlang(language)
    console.log('language', language)
    /* let timnum = 1717189200 //秒
    let nimsr = parseInt(new Date().getTime() /1000)
    if (nimsr >= timnum) {
      history.replace(`/app/hobiHost?broadcase=1&language=${this.state.language}`)
    } */
    // lang 文字对象
    // language 语言种类 (zh/ar/en)
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    let uid = await setUidToken(this.props.location.query)
    this.setState({
      uid: uid,
    })
    if (this.state.language == 'tr') {
      setDocumentTitle('Ajans Sistemi')
    } else if (this.state.language == 'en') {
      setDocumentTitle('Host System')
    } else if (this.state.language == 'ar') {
      setDocumentTitle(' نظام المضيف')
    }
    // console.log(uid, 'uid')
    await this.RunOnStart(uid)
    await this.getHostsystem()
  }

  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    // 用户id
    this.setState({
      uid: uid,
    })
  }

  getHostsystem = async () => {
    let res = await http.post('/web/hostsystem/info')
    // 判断状态
    if (res.code == 0 && res.res != null) {
      history.replace(`app/tradeUnion?language=${this.state.language}`)
    } else if (res.code == 0) {
      this.setState({ showApplaView: true })
    } else {
      this.setState({ showApplaView: true })
    }
  }

  hostStysem = () => {
    history.push(`app/tradeUnion?language=${this.state.language}`)
  }

  findHostSystem = () => {
    history.push(`app/find-hostJoin?language=${this.state.language}`)
  }
  render() {
    let { lang, showApplaView, language } = this.state
    return (
      showApplaView && (
        <div className={`new-host-system ${language == 'ar' ? 'in-tr' : ''}`}>
          <div className="welcom-title">{lang.welcomeText}</div>
          <div className="hostsystem-title">{lang.hostsystem}</div>
          <div className="icon-img"></div>
          <div className="join-host-system" onClick={this.findHostSystem}>
            <img
              className="icon-photo"
              src="/img/app/tradeUnion/icon_building_search_new.png"
            ></img>
            <div className="title">
              <div className="title-top">{lang.findanAgency}</div>
              <div className="title-buttom">{lang.findText}</div>
            </div>
            <img className="arrowhead" src="/img/app/tradeUnion/icon_chevron_forward_new.png"></img>
          </div>
          <div className="create-host-system" onClick={this.hostStysem}>
            <img className="icon-photo" src="/img/app/tradeUnion/icon_building_plus_new.png"></img>
            <div className="title">
              <div className="title-top">{lang.createanAgency}</div>
              <div className="title-buttom">{lang.craeteText}</div>
            </div>
            <img className="arrowhead" src="/img/app/tradeUnion/icon_chevron_forward_new.png"></img>
          </div>
        </div>
      )
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/ruby-join/index.js